var map = {
	"./FilterV2.svg": 50021,
	"./ab-test.svg": 99235,
	"./add-circle.svg": 75877,
	"./add-light.svg": 54115,
	"./add-tag.svg": 42879,
	"./add.svg": 71480,
	"./ai-tag-v2.svg": 4091,
	"./ai-tag.svg": 19686,
	"./angle-right-light.svg": 23662,
	"./armchair.svg": 62346,
	"./arrow-from-rec.svg": 9746,
	"./arrow-left.svg": 65648,
	"./arrow-right-light.svg": 85420,
	"./arrow-right.svg": 76415,
	"./arrow-rounded.svg": 10486,
	"./arrow.svg": 57190,
	"./arrows.svg": 65945,
	"./assign-to.svg": 91494,
	"./back-small.svg": 12816,
	"./back.svg": 79082,
	"./bell.svg": 73516,
	"./calendar.svg": 85033,
	"./calendarV2.svg": 72061,
	"./camera.svg": 58854,
	"./carousel-layout.svg": 25776,
	"./carpentry&diy.svg": 58679,
	"./cart.svg": 36849,
	"./catalog-manager.svg": 3614,
	"./check-rounded.svg": 89417,
	"./check.svg": 82497,
	"./chevron-left.svg": 12526,
	"./circle-warning.svg": 65412,
	"./clock.svg": 92075,
	"./close-light.svg": 26854,
	"./close-rounded-small.svg": 38991,
	"./close.svg": 35837,
	"./cloud-error-1.svg": 16869,
	"./cloud-error-2.svg": 80646,
	"./cloud-push.svg": 86447,
	"./cloud-success.svg": 59016,
	"./collage-layout.svg": 7773,
	"./collapse-menu.svg": 23270,
	"./collections-new.svg": 86387,
	"./collections.svg": 51758,
	"./comments-add.svg": 54027,
	"./comments.svg": 77089,
	"./copy.svg": 28552,
	"./csv-file.svg": 34404,
	"./d&d-list-item.svg": 28312,
	"./dash.svg": 5395,
	"./dashboard.svg": 17461,
	"./data-insights.svg": 9611,
	"./delete.svg": 90930,
	"./dependency-graph.svg": 72807,
	"./desktop-off.svg": 10265,
	"./desktop-on.svg": 72421,
	"./diamond.svg": 52497,
	"./documents.svg": 19243,
	"./dot.svg": 18860,
	"./dotSeparatorBig.svg": 75145,
	"./dotted-circle.svg": 80640,
	"./download.svg": 91303,
	"./drag-handle-vertical-double.svg": 29179,
	"./drag-handle.svg": 93584,
	"./drill.svg": 70022,
	"./duplicate.svg": 20430,
	"./edit.svg": 975,
	"./editV2.svg": 1995,
	"./ellipsis-menu.svg": 89602,
	"./email.svg": 11089,
	"./empty.svg": 51718,
	"./error.svg": 45119,
	"./experiments.svg": 2805,
	"./export.svg": 3205,
	"./external-link.svg": 839,
	"./eye-crossed.svg": 75498,
	"./eye.svg": 34426,
	"./filter.svg": 87985,
	"./flags/CA.svg": 57011,
	"./flags/DE.svg": 48270,
	"./flags/ES.svg": 14259,
	"./flags/FR.svg": 90971,
	"./flags/IL.svg": 55112,
	"./flags/IT.svg": 69536,
	"./flags/JP.svg": 43509,
	"./flags/KR.svg": 79704,
	"./flags/PL.svg": 73091,
	"./flags/PT.svg": 53003,
	"./flags/US.svg": 4995,
	"./frame.svg": 8174,
	"./gear.svg": 47046,
	"./generate-stars.svg": 34918,
	"./generate.svg": 21594,
	"./globe.svg": 5938,
	"./graph.svg": 76929,
	"./grid-layout.svg": 31314,
	"./group.svg": 7544,
	"./hollow-star.svg": 73139,
	"./home-decor.svg": 81286,
	"./home.svg": 74174,
	"./image.svg": 83922,
	"./import.svg": 95416,
	"./information.svg": 73787,
	"./informationV2.svg": 91071,
	"./informationV3.svg": 86318,
	"./json-file.svg": 60560,
	"./lexicon.svg": 56277,
	"./list-view.svg": 16779,
	"./lock.svg": 45482,
	"./log.svg": 1047,
	"./menu-placeholder.svg": 56970,
	"./merch-rules.svg": 3314,
	"./minus.svg": 48441,
	"./mobile-off.svg": 73605,
	"./mobile-on.svg": 20689,
	"./notifications-bell.svg": 15053,
	"./page-large.svg": 74220,
	"./page.svg": 18174,
	"./pencil.svg": 50184,
	"./pin.svg": 92528,
	"./plans.svg": 91029,
	"./player.svg": 4172,
	"./plus.svg": 24491,
	"./portrait.svg": 59610,
	"./preview-button.svg": 84038,
	"./preview.svg": 97881,
	"./price-tag.svg": 66517,
	"./product-tags.svg": 6326,
	"./prompt.svg": 93885,
	"./question-circle.svg": 79488,
	"./refresh-regenerate.svg": 42939,
	"./reset-arrow.svg": 81576,
	"./reviewitems.svg": 72965,
	"./right-arrow.svg": 14263,
	"./search-bold.svg": 52737,
	"./search-shop.svg": 83580,
	"./search.svg": 64343,
	"./select-caret.svg": 66433,
	"./setting.svg": 99941,
	"./shop-monitor.svg": 39314,
	"./shop.svg": 53383,
	"./shopper-experiences.svg": 24320,
	"./shopping-cart-on-monitor.svg": 54933,
	"./social-discovery.svg": 62843,
	"./sorting.svg": 88817,
	"./star.svg": 40815,
	"./stars.svg": 22414,
	"./start.svg": 33969,
	"./stop.svg": 6139,
	"./t-shirt.svg": 60670,
	"./tag-labels.svg": 23727,
	"./tag-managment.svg": 6102,
	"./team.svg": 49984,
	"./thematic-tag.svg": 72197,
	"./tooltip-questionmark-blue.svg": 83231,
	"./tooltip-questionmark-gray.svg": 38222,
	"./tooltip-questionmark.svg": 43150,
	"./trash-can.svg": 82082,
	"./trash.svg": 36891,
	"./triangle-sneak-peak.svg": 3660,
	"./triangle.svg": 11907,
	"./ui-templates.svg": 89387,
	"./upload-old.svg": 67248,
	"./upload.svg": 50600,
	"./user-circle.svg": 88215,
	"./user.svg": 10698,
	"./valid.svg": 76999,
	"./warning-outline.svg": 49636,
	"./warning.svg": 42865,
	"./xls-file.svg": 40169,
	"./yellow-star.svg": 39072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24078;